import { IAnimationIndexProvider } from "../IAnimationIndexProvider";

export class DefaultDiceAnimationIndexProvider implements IAnimationIndexProvider {
    private animationsAmount: number;

    public constructor(animationsAmount: number) {
        this.animationsAmount = animationsAmount;
    }

    public getAnimationIndex(): number {
        return Math.round(Math.random() * (this.animationsAmount - 1));
    }

}
